import { Box, Brand, Img, INK, LogoMark, Page, Text } from "../primitives";
/** Reference page 1. Only the recipient name is dynamic. */
// brandOffset: المدير يصعّد/ينزّل الشعار و«ارتيكا» سوه (pt)
export const COVER_BRAND_OFFSET_MIN = -60;
export const COVER_BRAND_OFFSET_MAX = 640;
export function CoverPage({ recipientName, brandOffset = 0 }) {
    return (<Page background={INK}>
      {/* photo panel, clipped at 533.4pt, darkened except for the last 11pt strip (as in the reference) */}
      <Box x={0} y={0} w={533.4} h={810} style={{ overflow: "hidden" }}>
        <Img src="/proposal-assets/template/cover-photo.jpg" x={-30} y={-7.7} w={583.4} h={825.2}/>
        <Box x={0} y={0} w={522.3} h={810} style={{ background: INK, opacity: 0.474 }}/>
      </Box>
      {/* balanced with «ارتيكا»: same 86pt margin from the page edge (1125 − 1039),
          full opacity, vertically centred on the word - it used to sit half off the page */}
      <LogoMark x={86} y={70.93 + brandOffset} w={32.8} color="#ffffff"/>
      <Brand right={1039} top={66 + brandOffset} size={32} color="#ffffff"/>

      {/* fixed label */}
      <Text right={1037.5} top={649} size={25} weight={700} color="#ffffff">
        اقتراح الى:
      </Text>
      {/* the only editable value on the cover */}
      <Text right={1043} top={689} size={25} weight={400} color="#ffffff" width={470} wrap style={{ lineHeight: 1.45 }}>
        {recipientName}
      </Text>
    </Page>);
}
